// src/hooks/useProducts.js
import { useState, useEffect } from 'react';
import { BASE_URL } from '../config';
const useProducts = () => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const response = await fetch(`${BASE_URL}api/v1/products`);
                if (!response.ok) {
                    throw new Error('Failed to fetch products');
                }
                const data = await response.json();
                console.log("products:",data);
                setProducts(data);
                localStorage.setItem("products", JSON.stringify(data));
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchProducts();
    }, []);

    const getNoDiscountProducts = () => {
        return products.filter(product => product.discount === 0);
    };

    const getDiscountProducts = () => {
        return products.filter(product => product.discount > 0);
    };

    return {
        products,
        loading,
        error,
        getNoDiscountProducts,
        getDiscountProducts
    };
};

export default useProducts;